import { api } from '../../api/client';
import BankConnectAlert from '../BankConnectAlert';
import React, { useState, useEffect } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { maybeStartAdminTour, startAdminTour, markTourDone } from '../../onboarding/adminTour';

interface NavItem {
  path: string;
  label: string;
  icon: string;
  roles?: string[];
}

interface NavGroup {
  label: string;
  icon: string;
  items: NavItem[];
}

const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Бүртгэл',
    icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5',
    items: [
      { path: '/units', label: 'Орон сууц', icon: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z' },
      { path: '/parking', label: 'Автозогсоол', icon: 'M8 7h8m-8 4h8m-6 4h4M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z' },
      { path: '/access-control', label: 'Нэвтрэх хяналт', icon: 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z' },
      { path: '/meters', label: 'Тоолуур', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
      { path: '/assets', label: 'Хөрөнгө', icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4' },
      { path: '/employees', label: 'Ажилчид', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
      { path: '/pets', label: 'Тэжээвэр амьтан', icon: 'M4.5 12.5c1.5 0 2.5-1.5 2.5-3S6 6.5 4.5 6.5 2 8 2 9.5 3 12.5 4.5 12.5zm15 0c1.5 0 2.5-1.5 2.5-3S21 6.5 19.5 6.5 17 8 17 9.5s1 3 2.5 3zM9 6c1 0 1.8-1.3 1.8-2.8S10 .5 9 .5 7.2 1.7 7.2 3.2 8 6 9 6zm6 0c1 0 1.8-1.3 1.8-2.8S16 .5 15 .5s-1.8 1.2-1.8 2.7S14 6 15 6zm-3 3c-2.5 0-6 3-6 6.5 0 2 1.5 3 3.5 3 1 0 1.8-.5 2.5-.5s1.5.5 2.5.5c2 0 3.5-1 3.5-3C18 12 14.5 9 12 9z' },
    ],
  },
  {
    label: 'Санхүү',
    icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    items: [
      { path: '/payments', label: 'Төлбөр', icon: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z' },
      { path: '/expenses', label: 'Зардал бүртгэх', icon: 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z' },
      { path: '/budget', label: 'Төсөв', icon: 'M9 7h6m0 10v-3m-3 3v-6m-3 6v-1m6-9a2 2 0 012 2v10a2 2 0 01-2 2H7a2 2 0 01-2-2V9a2 2 0 012-2' },
      { path: '/reconciliation', label: 'Тулгалт', icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' },
      { path: '/ebarimt', label: 'eBarimt', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
      { path: '/accounting', label: 'Нягтлан бодох', icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
    ],
  },
  {
    label: 'Үйл ажиллагаа',
    icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    items: [
      { path: '/maintenance', label: 'Өргөдөл', icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' },
      { path: '/governance', label: 'Санал асуулга', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' },
      { path: '/board', label: 'Зөвлөл', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z' },
      { path: '/official-docs', label: 'Албан бичиг', icon: 'M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9' },
      { path: '/documents', label: 'Баримт бичиг', icon: 'M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z' },
      { path: '/works', label: 'Хийж гүйцэтгэсэн ажлууд', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
    ],
  },
  {
    label: 'Мэдээлэл',
    icon: 'M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z',
    items: [
      { path: '/announcements', label: 'Зарлал', icon: 'M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z' },
      { path: '/notifications', label: 'Мэдэгдэл', icon: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' },
      { path: '/sms', label: 'SMS илгээх', icon: 'M8 10h8m-8 4h5m-9 7V6a2 2 0 012-2h12a2 2 0 012 2v9a2 2 0 01-2 2H8l-4 4z' },
      { path: '/contacts', label: 'Холбоо барих', icon: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z' },
    ],
  },
  {
    label: 'Тайлан',
    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    items: [
      { path: '/reports', label: 'Тайлан экспорт', icon: 'M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
    ],
  },
  {
    label: 'Тохиргоо',
    icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    items: [
      { path: '/tariffs', label: 'Тариф', icon: 'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z' },
      { path: '/admin-users', label: 'Хэрэглэгч', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z' },
      { path: '/invitations', label: 'Урилга', icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
      { path: '/new-tenants', label: 'Шинэ СӨХ', icon: 'M12 4v16m8-8H4', roles: ['platform_admin'] },
      { path: '/ppt-content', label: 'Танилцуулга (/ppt)', icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z', roles: ['platform_admin'] },
      { path: '/tenants', label: 'СӨХ удирдлага', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5', roles: ['platform_admin'] },
      { path: '/settings', label: 'Ерөнхий тохиргоо', icon: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4' },
      { path: '/phone-directory', label: 'Хэрэгцээт дугаар', icon: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z' },
    ],
  },
];

const TOP_ITEMS: NavItem[] = [
  { path: '/dashboard', label: 'Хянах самбар', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0h4' },
];

const DISTRICT_ITEMS: NavItem[] = [
  { path: '/district', label: 'СӨХ жагсаалт', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5' },
];

function NavIcon({ d }: { d: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d={d} />
    </svg>
  );
}

function ChevronIcon({ open }: { open: boolean }) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{
      transition: 'transform .2s', transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
      flexShrink: 0,
    }}>
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

function useIsMobile(breakpoint = 900) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return isMobile;
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Хуудас солигдоход мобайл drawer-ийг хаана.
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Мобайл дээр цонгоо жижиг үед sidebar-ийг collapse хийхгүй (drawer нь бүтэн өргөнтэй).
  const effectiveCollapsed = isMobile ? false : collapsed;

  // First-login onboarding tour (per user, per device). District users have
  // a single-page nav, so the grouped tour doesn't apply to them.
  useEffect(() => {
    if (user?.role !== 'district') {
      maybeStartAdminTour(user?.id || user?.email || user?.username);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const initialOpen = NAV_GROUPS.reduce<Record<string, boolean>>((acc, g) => {
    acc[g.label] = g.items.some(i => location.pathname === i.path || (i.path !== '/dashboard' && location.pathname.startsWith(i.path)));
    return acc;
  }, {});
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>(initialOpen);

  const toggleGroup = (label: string) => {
    setOpenGroups(prev => ({ ...prev, [label]: !prev[label] }));
  };

  const isActive = (path: string) => location.pathname === path || (path !== '/dashboard' && location.pathname.startsWith(path));

  const linkStyle = (active: boolean): React.CSSProperties => ({
    display: 'flex', alignItems: 'center', gap: 10,
    padding: effectiveCollapsed ? '9px 14px' : '8px 12px 8px 36px',
    textDecoration: 'none',
    color: active ? '#fff' : 'rgba(255,255,255,.6)',
    background: active ? 'linear-gradient(135deg, #2f7d52, #236844)' : 'transparent',
    borderRadius: 8, margin: '1px 0',
    fontSize: 13, fontWeight: active ? 600 : 400,
    transition: 'all .15s',
  });

  return (
    <div className="theme-light" style={{ display: 'flex', flexDirection: 'row', minHeight: '100vh', fontFamily: "'Inter', sans-serif" }}>
      {/* Мобайл backdrop */}
      {isMobile && mobileOpen && (
        <div
          onClick={() => setMobileOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 900 }}
        />
      )}

      <aside style={{
        width: effectiveCollapsed ? 68 : 260,
        background: 'linear-gradient(180deg, #1a3a2a 0%, #1c2b22 100%)',
        color: '#fff',
        transition: isMobile ? 'transform 0.25s' : 'width 0.2s',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        // Цэсийг байнга дэлгэцэнд тогтоож (fixed), баруун контент гүйхэд
        // дагаж хөдлөхгүй. Мобайл дээр drawer, десктоп дээр зүүн талд бэхлэгдэнэ.
        position: 'fixed' as const,
        top: 0, left: 0, height: '100vh',
        zIndex: isMobile ? 1000 : 500,
        ...(isMobile ? {
          transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
          boxShadow: mobileOpen ? '4px 0 24px rgba(0,0,0,0.3)' : 'none',
        } : {}),
      }}>
        {/* Logo */}
        <div style={{
          padding: effectiveCollapsed ? '20px 12px' : '20px 20px',
          borderBottom: '1px solid rgba(255,255,255,.08)',
          display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <div style={{
            width: 38, height: 38, borderRadius: 10, flexShrink: 0,
            background: 'linear-gradient(135deg, #2f7d52, #236844)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="22" height="22" viewBox="0 0 48 48" fill="none">
              <path d="M14 22 L14 41 L23 41 L23 33 L25 33 L25 41 L34 41 L34 22" stroke="#fff" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />
              <path d="M9 24 L24 11 L39 24" stroke="#fff" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />
              <path d="M24 19c-2.4-2.6-6.6-1.3-6.6 2 0 2.6 3.4 4.7 6.6 7 3.2-2.3 6.6-4.4 6.6-7 0-3.3-4.2-4.6-6.6-2Z" fill="#ffd166" />
            </svg>
          </div>
          {!effectiveCollapsed && (
            <div style={{ lineHeight: 1, overflow: 'hidden' }}>
              <div style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 16, color: '#fff' }}>Сайн хөрш</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,.5)', marginTop: 3 }}>Удирдлагын систем</div>
            </div>
          )}
          <button
            onClick={() => isMobile ? setMobileOpen(false) : setCollapsed(!collapsed)}
            style={{
              marginLeft: 'auto', background: 'none', border: 'none',
              color: 'rgba(255,255,255,.4)', cursor: 'pointer', fontSize: 16,
              padding: 4, display: 'flex',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d={isMobile ? 'M6 18L18 6M6 6l12 12' : (collapsed ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6')} />
            </svg>
          </button>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '10px 8px', overflowY: 'auto' }}>
          {/* District-only nav */}
          {user?.role === 'district' && DISTRICT_ITEMS.map(item => (
            <Link key={item.path} to={item.path} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '10px 14px', textDecoration: 'none',
              color: isActive(item.path) ? '#fff' : 'rgba(255,255,255,.6)',
              background: isActive(item.path) ? 'linear-gradient(135deg, #2f7d52, #236844)' : 'transparent',
              borderRadius: 10, margin: '1px 0',
              fontSize: 13.5, fontWeight: isActive(item.path) ? 600 : 400,
              transition: 'all .15s',
            }}>
              <NavIcon d={item.icon} />
              {!effectiveCollapsed && <span>{item.label}</span>}
            </Link>
          ))}

          {/* Top-level items (non-district) */}
          <TenantSwitcher collapsed={!!effectiveCollapsed} platform={user?.role === 'platform_admin'} />
          {user?.role !== 'district' && TOP_ITEMS.map(item => (
            <Link key={item.path} to={item.path} data-tour={`nav${item.path.replace('/', '-')}`} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '10px 14px',
              textDecoration: 'none',
              color: isActive(item.path) ? '#fff' : 'rgba(255,255,255,.6)',
              background: isActive(item.path) ? 'linear-gradient(135deg, #2f7d52, #236844)' : 'transparent',
              borderRadius: 10, margin: '1px 0',
              fontSize: 13.5, fontWeight: isActive(item.path) ? 600 : 400,
              transition: 'all .15s',
            }}>
              <NavIcon d={item.icon} />
              {!effectiveCollapsed && <span>{item.label}</span>}
            </Link>
          ))}

          {!effectiveCollapsed && user?.role !== 'district' && <div style={{ height: 8 }} />}

          {/* Grouped items (hidden for district users) */}
          {user?.role !== 'district' && NAV_GROUPS.map(group => {
            const groupActive = group.items.some(i => isActive(i.path));
            const isOpen = openGroups[group.label] || false;
            const visibleItems = group.items.filter(i => !i.roles || i.roles.includes(user?.role));
            if (visibleItems.length === 0) return null;

            if (effectiveCollapsed) {
              return visibleItems.map(item => (
                <Link key={item.path} to={item.path} title={item.label} style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  padding: '9px 14px', textDecoration: 'none',
                  color: isActive(item.path) ? '#fff' : 'rgba(255,255,255,.5)',
                  background: isActive(item.path) ? 'linear-gradient(135deg, #2f7d52, #236844)' : 'transparent',
                  borderRadius: 8, margin: '1px 0', transition: 'all .15s',
                }}>
                  <NavIcon d={item.icon} />
                </Link>
              ));
            }

            return (
              <div key={group.label} style={{ marginBottom: 4 }}>
                <button
                  onClick={() => toggleGroup(group.label)}
                  data-tour={`nav-group-${group.label}`}
                  style={{
                    width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                    padding: '9px 14px', background: 'none', border: 'none',
                    color: groupActive ? '#fff' : 'rgba(255,255,255,.45)',
                    cursor: 'pointer', fontSize: 11.5, fontWeight: 700,
                    textTransform: 'uppercase', letterSpacing: 0.6,
                    borderRadius: 8, transition: 'all .15s',
                  }}
                >
                  <NavIcon d={group.icon} />
                  <span style={{ flex: 1, textAlign: 'left' }}>{group.label}</span>
                  <ChevronIcon open={isOpen} />
                </button>

                {isOpen && (
                  <div style={{ overflow: 'hidden' }}>
                    {visibleItems.map(item => (
                      <Link key={item.path} to={item.path} style={linkStyle(isActive(item.path))}>
                        <NavIcon d={item.icon} />
                        <span>{item.label}</span>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* User footer */}
        <div style={{
          padding: effectiveCollapsed ? '16px 10px' : '16px 20px',
          borderTop: '1px solid rgba(255,255,255,.08)',
        }}>
          {!effectiveCollapsed && (
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,.5)', marginBottom: 10 }}>
              {user?.username || 'Admin'}
            </div>
          )}
          {user?.role !== 'district' && (
            <button
              data-tour="help-button"
              title="Танилцуулга үзэх"
              onClick={() => startAdminTour(() => markTourDone(user?.id || user?.email || user?.username || ''))}
              style={{
                width: '100%', padding: '8px 12px', marginBottom: 8,
                background: 'rgba(255,209,102,.12)', border: '1px solid rgba(255,209,102,.25)',
                color: '#ffd166', borderRadius: 8,
                cursor: 'pointer', fontSize: 13,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                transition: 'all .15s',
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {!effectiveCollapsed && 'Танилцуулга'}
            </button>
          )}
          <button onClick={logout} style={{
            width: '100%', padding: '8px 12px',
            background: 'rgba(255,255,255,.08)', border: '1px solid rgba(255,255,255,.1)',
            color: 'rgba(255,255,255,.7)', borderRadius: 8,
            cursor: 'pointer', fontSize: 13,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            transition: 'all .15s',
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
            </svg>
            {!effectiveCollapsed && 'Гарах'}
          </button>
        </div>
      </aside>

      <main style={{
        flex: 1,
        background: '#f4f1e8',
        overflow: 'auto',
        minWidth: 0,
        // Цэс fixed болсон тул түүний өргөнөөр зүүнээс зай авна (десктоп).
        marginLeft: isMobile ? 0 : (effectiveCollapsed ? 68 : 260),
        transition: 'margin-left 0.2s',
      }}>
        {/* Мобайл дээд bar (hamburger) */}
        {isMobile && (
          <div style={{
            position: 'sticky', top: 0, zIndex: 800,
            display: 'flex', alignItems: 'center', gap: 12,
            background: '#1c2b22', padding: '12px 16px',
          }}>
            <button
              onClick={() => setMobileOpen(true)}
              aria-label="Цэс"
              style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', padding: 4, display: 'flex' }}
            >
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <span style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 16, color: '#fff' }}>Сайн хөрш</span>
          </div>
        )}
        <div style={{ padding: isMobile ? '16px 14px 40px' : 28, maxWidth: 1400 }}>
          <BankConnectAlert tenantId={user?.tenant_id} role={user?.role} />
          <Outlet />
        </div>
      </main>
    </div>
  );
}


/** Платформ админ: аль СӨХ-ийн нэрийн өмнөөс ажиллахаа сонгоно (X-Tenant-Id толгой). Сонгоод хуудас дахин ачаална. */
function TenantSwitcher({ collapsed, platform }: { collapsed: boolean; platform?: boolean }) {
  const [tenants, setTenants] = React.useState<{ id: string; name: string; is_home?: boolean }[]>([]);
  const [homeId, setHomeId] = React.useState('');
  const cur = localStorage.getItem('platform_tenant_id') || '';
  React.useEffect(() => {
    if (platform) {
      api.get<any>('/platform/tenants?limit=500').then(r => setTenants((r?.items || []).map((t: any) => ({ id: t.id, name: t.name })))).catch(() => {});
    } else {
      // Нэг эрх → олон СӨХ (хотхон): нэгээс олон бол л сонголт харуулна
      api.get<any>('/admin/me/tenants').then(r => { setTenants(r?.items || []); setHomeId(r?.home_id || ''); }).catch(() => {});
    }
  }, [platform]);
  const pick = (id: string) => {
    if (id && id !== homeId) localStorage.setItem('platform_tenant_id', id); else localStorage.removeItem('platform_tenant_id');
    window.location.reload();
  };
  if (!platform && tenants.length < 2) return null;
  if (collapsed) return <div title="СӨХ сонгох" style={{ textAlign: 'center', padding: '6px 0', fontSize: 11, color: 'rgba(255,255,255,.7)' }}>СӨХ</div>;
  return (
    <div style={{ padding: '6px 12px 10px' }}>
      <div style={{ fontSize: 10.5, letterSpacing: '.06em', textTransform: 'uppercase', color: 'rgba(255,255,255,.55)', marginBottom: 4 }}>{platform ? 'Ажиллах СӨХ' : 'Хотхон / СӨХ'}</div>
      <select value={cur || (platform ? '' : homeId)} onChange={e => pick(e.target.value)} style={{ width: '100%', padding: '7px 8px', borderRadius: 8, border: '1px solid rgba(255,255,255,.25)', background: 'rgba(255,255,255,.1)', color: '#fff', fontSize: 13 }}>
        {platform && <option value="" style={{ color: '#1c2b22' }}>Өөрийн СӨХ (анхдагч)</option>}
        {tenants.map(t => <option key={t.id} value={t.id} style={{ color: '#1c2b22' }}>{t.name}{t.is_home ? ' (үндсэн)' : ''}</option>)}
      </select>
    </div>
  );
}
